export default __webpack_public_path__ + "static/media/Ζενιθ_ΦΑ.f6279092.png";